import { Injectable } from '@angular/core';

import {
	GetSimilarityRecommendationsResponse,
	NodesRecommendationResponse,
} from '@reach/interfaces/recommendations/recommendations.responses';

import { BaseApiService } from '~app-client/api/_internal';
import { ReachNodeId } from '~app-client/core/types';

@Injectable({ providedIn: 'root' })
export class RecommendationsApiService extends BaseApiService {
	protected commonPath = ['recommendations'];

	public async getSimilarNodes(
		nodeId: ReachNodeId
	): Promise<GetSimilarityRecommendationsResponse> {
		const params = { t: `${this.cacheTimer}` };
		return await this.http.get<GetSimilarityRecommendationsResponse>(
			this.url('similarity', nodeId),
			params
		);
	}

	public async getTags(nodeId: ReachNodeId): Promise<NodesRecommendationResponse> {
		const params = { t: `${this.cacheTimer}` };
		return await this.http.get<NodesRecommendationResponse>(this.url('tags', nodeId), params);
	}

	public async retryTags(nodeId: ReachNodeId): Promise<NodesRecommendationResponse> {
		const body = { nodeIds: [nodeId] };
		return await this.http.post<NodesRecommendationResponse>(this.url('tags'), body);
	}
}
